
























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/** 1行あたりのおおよその文字数（プレビュー幅想定）。これを超えるか改行があればトグル表示 */
const PREVIEW_LONG_THRESHOLD = 70;

@Component
export default class TableCellPreviewBar extends Vue {
  @Prop({ type: String, default: "" }) readonly value!: string;

  expanded = false;

  @Watch("value")
  onValueChange(): void {
    this.expanded = false;
  }

  get isLongText(): boolean {
    const v = this.value || "";
    if (!v) return false;
    if (/[\r\n]/.test(v)) return true;
    return v.length > PREVIEW_LONG_THRESHOLD;
  }

  get textareaRows(): number {
    if (!this.isLongText) return 1;
    return this.expanded ? 2 : 1;
  }
}
